import { defineAsyncComponent } from 'vue'
import { usePage } from '@inertiajs/vue3'

interface PanelData {
  panelOpened: boolean
  localPanel: string | false
  panelData: Record<string, unknown>
}

type PanelContext = PanelData & {
  panel: string | false
  asyncPanel: unknown
}

const usePanel = {
  data(): PanelData {
    return {
      panelOpened: false,
      localPanel: false,
      panelData: {},
    }
  },
  computed: {
    panel() {
      if (!usePage().props) {
        return false
      }
      return (this as unknown as PanelContext).localPanel
    },
    asyncPanel() {
      const panel = (this as unknown as PanelContext).panel
      return panel
        ? defineAsyncComponent(() => import(`../apps/dashboard/panels/${panel}.vue`))
        : false
    },
  },
  watch: {
    asyncPanel(newVal: unknown): void {
      const self = this as unknown as PanelContext
      self.panelOpened = !!newVal
    },
  },
  methods: {
    closePanel(): void {
      const self = this as unknown as PanelContext
      if (self.asyncPanel) {
        self.panelOpened = false
        self.localPanel = false
        self.panelData = {}
      }
    },
    openLocalPanel(panelName: string, panelData: Record<string, unknown> = {}): void {
      const self = this as unknown as PanelContext
      self.localPanel = panelName
      self.panelData = panelData
    },
  },
}

export { usePanel }
export type { PanelData }
